import React from 'react';
import { FieldValues } from '../IMSFormFieldsTypes';

interface Component {
  id: React.Key | null | undefined;
  datatype: string;
  label_display?: any;
  label?: any;
}

interface Group {
  id: React.Key | null | undefined;
}

interface IMSFormAccordionCheckboxProps {
  component: Component;
  group: Group;
  fieldValues: FieldValues;
  handleFieldChange: (groupId: string, componentId: string, value: any, datatype: string) => void;
}

const IMSFormAccordionCheckbox: React.FC<IMSFormAccordionCheckboxProps> = ({
  component,
  group,
  fieldValues,
  handleFieldChange
}) => {
  const componentIdStr = component.id != null ? String(component.id) : '';
  const groupIdStr = group.id != null ? String(group.id) : '';

  const isChecked = componentIdStr && fieldValues[componentIdStr] ?
    (fieldValues[componentIdStr]?.value === true || fieldValues[componentIdStr] === true || String(fieldValues[componentIdStr]?.value) === 'true' || String(fieldValues[componentIdStr]) === 'true')
    : false;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (componentIdStr && groupIdStr) {
      handleFieldChange(groupIdStr, componentIdStr, event.target.checked, component.datatype);
    }
  };

  return (
    <>
      <input
        type="checkbox"
        style={{ marginRight: '5px' }}
        checked={isChecked}
        onChange={handleChange}
      />
      <label>
        {component.label_display || component.label}
      </label>
    </>
  );
};

export default IMSFormAccordionCheckbox;
